import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import {
  ParagraphCtaInitModel, ParagraphCtaInitVariables,
  ParagraphCtaModel,
  ParagraphCtaVariables,
} from '../../../../../models/email-template/paragraph-cta.interface';
import { BaseComponent } from '../../../common/BaseComponent';

@Component({
    selector: 'app-paragraphcta',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './paragraph-cta.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './paragraph-cta.component.scss'
})
export class ParagraphCtaComponent extends BaseComponent implements OnInit {
  @Input() block: ParagraphCtaModel = new ParagraphCtaInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ParagraphCtaInitVariables()
    }
  }

  //placeholders:
  introTextPlaceholder: string = 'Enter Intro Text';
  mainCtaLinkPlaceholder: string = 'Enter Main CTA Link';
  mainCtaTextPlaceholder: string = 'Enter Main CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ParagraphCtaVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ParagraphCtaVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
